var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYubiMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.01,29.5c-109,0-111,147-111,178c0,25.99,5.81,249.76,6.85,280.67c0.08,2.43,2.05,4.36,4.48,4.41 c0,0,62.66,1.92,99.66,1.92s99.66-1.92,99.66-1.92c2.43-0.05,4.4-1.98,4.48-4.41c1.05-30.91,6.85-254.69,6.85-280.67 C367.01,176.5,365.01,29.5,256.01,29.5z M308.85,216.35c-0.33,1.36-1.55,2.3-2.95,2.3l-49.82-0.16l-49.82,0.16 c-1.4,0-2.61-0.95-2.95-2.3c-2.01-8.32-8.54-38.45-8.54-78.52c0-33.34,4.3-81.74,13.22-89.87c12.95-9.06,28.76-14.45,48.09-14.45 s35.14,5.4,48.09,14.45c8.92,8.13,13.22,56.53,13.22,89.87C317.39,177.9,310.86,208.01,308.85,216.35z M298.89,208.88 c-0.27,1.24-1.26,2.1-2.4,2.1L256,210.84l-40.49,0.15c-1.14,0-2.12-0.86-2.4-2.1c-1.63-7.59-6.94-35.07-6.94-71.62 c0-30.41,3.5-74.55,10.74-81.96c10.53-8.26,23.38-13.18,39.09-13.18s28.56,4.92,39.09,13.18c7.25,7.42,10.74,51.56,10.74,81.96 C305.83,173.82,300.52,201.28,298.89,208.88z M280.51,345.5h-24.5h-24.5c-2.21,0-4-1.79-4-4s1.79-4,4-4h24.5h24.5c2.21,0,4,1.79,4,4 S282.72,345.5,280.51,345.5z M301.01,302.5h-45h-45c-2.21,0-4-1.79-4-4s1.79-4,4-4h45h45c2.21,0,4,1.79,4,4 S303.22,302.5,301.01,302.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYubiMini);
export default __webpack_public_path__ + "static/media/yubi_mini.4216e8c1aabe4423cd4ece630e95c608.svg";
export { ForwardRef as ReactComponent };